<template>
  <a-card :bordered="false">
    <a-form class="m-b-20" ref='form' :model='search' :initialValues="search" :onFinish='pageSearchChange'
      layout='inline'>
      <a-form-item label="" name='keyword'>
        <a-input-group compact :style="{width:'360px'}">
          <a-select v-model:value="search.keyword_type" style="width: 30%" @change="inputSelect">
            <a-select-option value="transfer_warehousing_sn">调仓单号</a-select-option>
            <a-select-option value="create_role_name">创建人</a-select-option>
          </a-select>
          <a-input style="width: 70%" v-model:value="search.keyword" placeholder="请输入关键词进行搜索" />
        </a-input-group>
      </a-form-item>
      <a-form-item label="创建时间" name='time'>
        <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD ' format='YYYY-MM-DD' @change="changTime" />
      </a-form-item>
      <a-form-item>
        <a-button type="primary" htmlType='submit'>搜索</a-button>
      </a-form-item>
    </a-form>
    <a-table :pagination='false' :loading='listLoading' bordered rowKey='transfer_warehouse_id' :columns='columns' :data-source='list'>
      <template v-slot:action="{ record }">
        <a-dropdown>
          <a class="ant-dropdown-link"> 操作
            <DownOutlined />
          </a>
          <template v-slot:overlay>
            <a-menu>
              <a-menu-item>
                <a href="javascript:;"  @click="goAction(record.transfer_warehouse_id)">调仓</a>
              </a-menu-item>
              <a-menu-item>
                <router-link tag="a" target="_blank" :to="'/antiFleeingGoods/documents/transferDetails?id='+record.transfer_warehouse_id">查看详情</router-link>
              </a-menu-item>
            </a-menu>
          </template>
        </a-dropdown>
      </template>
    </a-table>
    <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page"
      :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
    <a-modal :keyboard="false" :maskClosable='false' v-model:visible="showAction" destroyOnClose :footer='null' centered>
      <p class="text-ac s_font_b fz-18 m-b-20">您还有未完成发货的调仓单，是否继续上一次的编辑？</p>
      <p class="text-ac m-b-50">选择继续当前操作，未完成的单据将进行取消操作</p>
      <div class="text-ac">
        <a-button @click="selectAction('goOn')">继续当前操作</a-button>
        <a-button type="primary" class="m-l-20" @click="selectAction('goBack')">返回上一次编辑</a-button>
      </div>
    </a-modal>
  </a-card>
</template>
<script>
  import {  DownOutlined } from "@ant-design/icons-vue";
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { message } from "ant-design-vue";
  import { getRouter } from "@/utils/app";
  import { setPageState, getPageState } from "@/utils/pageState";
  import { getTransferWarehousing,transferWarehousingPending } from '@/api/antiFleeing';
  import { iscode } from "@/utils/app";
  import useTableSearch from "@/hooks/useTableSearch";
  // 初始化默认筛选项数值
  let defSearch = {
    start_time: "",
    end_time: "",
    page: 1,
    limit: 10,
    keyword_type: "transfer_warehousing_sn",
    keyword: "",
    transfer_status:1
  };
  export default {
    components: { DownOutlined },
    setup() {
      const state = reactive({
        time: [],
        showAction:false,
        itemId:''
      });
      let columns = [
        {
          title: "调仓单号",
          dataIndex: "transfer_warehousing_sn",
          key: "transfer_warehousing_sn",
        },
        {
          title: "创建时间",
          dataIndex: "created_at",
          key: "created_at",
        },
        {
          title: "创建人",
          dataIndex: "create_role_name",
          key: "create_role_name",
        },
        {
          title: "备注",
          dataIndex: "remark",
          key: "remark",
        },
        {
          title: "操作",
          key: "action",
          slots: { customRender: "action" },
        },
      ];
      const $router = inject("$router");
      const $Modal = inject("$Modal");
      const changTime = (e) => {
        search.value.start_time = e[0];
        search.value.end_time = e[1];
      };
      // 去调仓
      const goAction = (id) =>{
        state.itemId = id
        $router.push('/antiFleeingGoods/warehouseTransfer/transferWarehouse?id='+state.itemId)
      }
      // 选择操作
      const selectAction = (type) =>{
        $router.push('/antiFleeingGoods/warehouseTransfer/transferWarehouse?id='+state.itemId)
      }
      const {
        pageCurrentChange,
        pageSizeChange,
        search,
        list,
        initData,
        total,
        pageSearchChange,
        listLoading,
      } = useTableSearch({ data: defSearch });
      const tableHoosks = {
        pageCurrentChange,
        pageSizeChange,
        search,
        initData,
        list,
        total,
        pageSearchChange,
        listLoading,
      };

      onMounted(() => {
        // 查看是否有留存状态，有则替换
        let pageState = getPageState(getRouter().route.path);
        if (pageState) {
          search.value = Object.assign(search.value, pageState);
        }
        tableHoosks.initData(getTransferWarehousing, search.value);
      });
      return {
        ...toRefs(state),
        ...tableHoosks,
        columns,
        changTime,
        goAction,
        selectAction
      };
    },
  };
</script>